import type { LayoutBlock } from '@web-studio/shared-schemas';
import { canonicalizeMediaUrl, resolvePublicUploadUrl } from './imageProxy';

export function pickMediaUrl(block: LayoutBlock, key: string): string | undefined {
  const url = block.media?.[key];
  if (typeof url !== 'string' || url.length === 0) {
    return undefined;
  }
  return resolvePublicUploadUrl(canonicalizeMediaUrl(url));
}
